<!--P061、P062、P076、P077-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy">要货调价处理</div>
    </div>
    <!--查询栏-->
    <div class="cs_margin_top div_search bg_search cs_padding">
      <div class="cs_title_primary cs_text_default type_info_search">配送中心</div>
      <web-select :options="search.dcList"
                  @option-key="updateDc"
                  v-model="search.dcName"
                  class="cs_input cs_radius_lg edtxt_info_search width_240"></web-select>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">调价门店</div>
      <div class="cs_radius_lg txt_info_search margin_left_8 width_80">{{shopSelectedList.length}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left_xs">家</div>
      <button @click="btnShop" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">生效时间</div>
      <div v-show="search.isEffect" class="cs_radius_lg txt_info_search width_240">{{search.effectTime}}</div>
      <input v-show="!search.isEffect" v-model="search.effectTime" id="effectTime" class="cs_input cs_radius_lg edtxt_info_search width_240" placeholder="请输入" readonly>
      <div class="div_cbtn cs_margin_left_sm cs_margin_top_xs">
        <span class="icon_cbtn" :class="{'on':search.isEffect}"></span>
        <input value="true" class="txt_cbtn" :checked='search.isEffect' @click="check1" type="checkbox">立即生效
      </div>
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">备注</div>
      <input v-model="search.hint" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm ui_margin_left_44 width_408" placeholder="请输入">
    </div>
    <!--表格-->
    <div class="cs_margin_top div_search_result cs_padding_top">
      <div class="div_operation_table">
        <button @click="btnAddMaterial" class="cs_btn cs_btn_sm ui_btn_blue cs_fr cs_margin_left_sm"
                type="button">添加
        </button>
        <button @click="btnDeleteMaterial" class="cs_btn cs_btn_sm ui_btn_ghost_blue cs_fr"
                type="button">删除
        </button>
      </div>
      <div class="cs_margin_top_sm div_table">
        <table class="cs_table cs_td_divider_none cs_thead_fixed" width="100%">
          <thead>
          <tr>
            <th width="40px">序号</th>
            <th width="151px">货品编号</th>
            <th width="280px">货品名称</th>
            <th width="100px">规格</th>
            <th width="130px">库存单位</th>
            <th width="184px">当前配送价</th>
            <th width="184px">调后配送价</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in orderList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTr(item)">
            <td width="40px">{{index+1}}</td>
            <td width="151px">{{item.materialNum}}</td>
            <td width="280px">{{item.name}}</td>
            <td width="100px">{{item.materialSpecs}}</td>
            <td width="130px">{{item.unit}}</td>
            <td width="184px">{{item.unitPrice}}</td>
            <td width="184px">{{item.newPrice}}</td>
          </tr>
          <template v-if="PAGE_SIZE>orderList.length">
            <tr v-for="(item,index) in (PAGE_SIZE-orderList.length)">
              <td width="40px"></td>
              <td width="151px"></td>
              <td width="280px"></td>
              <td width="100px"></td>
              <td width="130px"></td>
              <td width="184px"></td>
              <td width="184px"></td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
      <div class="cs_text_sm cs_text_primary cs_margin_top_xs txt_hint_table">制单时间：{{getNowDate()}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;制单人：{{userName}}</div>
      <div class="div_operation_table">
        <button @click="btnConfirm" class="cs_btn_dialog ui_btn_blue cs_fr"
                type="button">确认调价
        </button>
      </div>
    </div>
    <div class="div_bottom"></div>

    <!--编辑调价门店弹窗，默认显示-->
    <div v-if="isDialogShopShow" class="ui_div_dialog cs_scrollable_vertical">
      <div class="ui_dialog_container" style="width:542px;height:622px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑调价门店</div>
        </div>
        <div class="cs_margin_top_lg div_table">
          <table class="cs_table cs_thead_fixed cs_td_divider_none" width="100%">
            <thead>
            <tr>
              <th width="44px">序号</th>
              <th width="128px">门店编号</th>
              <th width="100%">门店名称</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in shopList" :class="{ 'cs_tr_selected': item.isSelected}" @click="btnSelectTableTrDialogShop(item)">
              <td width="44px">{{index+1}}</td>
              <td width="128px">{{item.shopNum}}</td>
              <td width="100%">{{item.shopName}}</td>
            </tr>
            <template v-if="PAGE_SIZE>shopList.length">
              <tr v-for="(item,index) in (PAGE_SIZE-shopList.length)">
                <td width="40px"></td>
                <td width="128px"></td>
                <td width="100%"></td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogShop">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmShopDialog">确定</button>
        </div>
      </div>
    </div>
    <!--添加货品弹窗，默认隐藏-->
    <div v-if="isDialogMaterialShow" class="ui_div_dialog">
      <div class="ui_dialog_container" style="width:414px;height:466px;padding: 24px;">
        <div class="ui_divider_title">
          <div class="divider_title_info"></div>
          <div class="title_info">添加调价货品</div>
        </div>
        <div class="cs_margin_top_lg div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">货品</div>
          <search-select :options="dialogMaterial.materialSearchItems"
                         @option-key="updateMaterialNameMaterial"
                         v-model="dialogMaterial.materialName"
                         :search-fn="acquireMaterialItemMaterial"
                         class="cs_input cs_radius_lg edtxt_info_search width_246 ui_margin_left_58"></search-select>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">规格</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_58">{{dialogMaterial.materialSpecs}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">库存单位</div>
          <div class="cs_radius_lg txt_info_search width_246 ui_margin_left_30">{{dialogMaterial.unit}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">当前配送价</div>
          <div class="cs_radius_lg txt_info_search width_246">{{dialogMaterial.unitPrice}}</div>
        </div>
        <div class="margin_top_12 div_search">
          <div class="cs_title_primary cs_text_default type_info_search margin_left_18">调后配送价</div>
          <input v-model="priceDialog" class="cs_input cs_radius_lg edtxt_info_search width_246" @keyup="inputLimitPositiveFloat($event)" @blur="priceDialog=formatPositiveFloat($event)">
        </div>
        <div class="cs_margin_top_sm cs_text_sm txt_hint_dialog cs_align_center">{{dialogMaterial.hintDialog}}</div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogMaterial">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmMaterialDialog">确定</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {Page, PAGE_SIZE} from "../../assets/utils/constants"
  import StorageConst from "../../assets/utils/StorageConst";
  export default {
    name: "RequirePriceHandle",
    components: {SearchSelect, WebSelect},
    data: function () {
      return {
        search: {
          effectTime: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_HANDLE,"effectTime", this.getNextHour()),
          isEffectList: [],
          isEffect: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_HANDLE,"isEffect", false),
          dcId: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_HANDLE,"dcId", ""),
          dcName: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_HANDLE,"dcName", ""),
          dcList: [],
          hint: this.getStoreItem(StorageConst.LOCAL_PAGE_LIST.REQUIRE_PRICE_HANDLE,"hint", ""),
        },
        orderList: [],
        selectedId: "",
        isDialogShopShow: false,
        shopList: [],
        shopSelectedList: [],
        isDialogMaterialShow: false,
        dialogMaterial: {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          unit: "",
          unitPrice: "",
          materialNum: "",
          name: "",
          hintDialog: "",
          materialSpecs:""
        },
        priceDialog: "",
        PAGE_SIZE:10,
        userName:"",
      }
    },
    created: function () {
      this.userName = this.isEmpty(this.$cookies.get(StorageConst.COOKIE_STAFF_NAME))?"":this.$cookies.get(StorageConst.COOKIE_STAFF_NAME);
      this.showDc();
    },
    mounted: function () {
      const that = this;
      laydate.render({
        elem: '#effectTime',
        btns:["now","confirm"],
        type: "datetime",
        format: "yyyy-MM-dd HH时",
        done(value) {
          that.search.effectTime = value;
        },
      });
    },
    methods:{
      btnConfirm(){
        if(this.isEmptySelect(this.search.dcId)){
          this.$toast("请选择配送中心");
          return
        }
        if(this.shopSelectedList.length<1){
          this.$toast("请选择调价门店");
          return
        }
        if(this.orderList.length<1){
          this.$toast("请选择调价货品");
          return
        }
        let selectedList = [];
        this.orderList.forEach((item) => {
          let selectItem = {
            materialId: item.materialId,
            newPrice: item.newPrice.trim()
          };
          console.log("newPrice=="+item.newPrice+"=");
          selectedList.push(selectItem);
        });
        //判断生效时间
        if(!this.search.isEffect && this.isEmpty(this.search.effectTime)){
          this.$toast("请选择生效时间");
          return
        }
        let time = this.search.isEffect?"立即生效":this.search.effectTime;
        this.$alert("本次发生调价门店共"+this.shopSelectedList.length+"家，发生调价货品共 "+selectedList.length+" 种<br>生效时间："+time+"<br>确认进行调价吗？", (clickConfirm) => {
          if (clickConfirm) {
            let effectTimeSubmit = this.isEmpty(this.search.effectTime)?"":this.search.effectTime.substring(0,13);
            let shopIds = this.shopSelectedList[0];
            for(let i=1;i<this.shopSelectedList.length;i++){
              shopIds = shopIds + "," + this.shopSelectedList[i];
            }
            this.$ajax.priceManage.addRequirePriceManage.bind(this)(this.search.dcId,this.search.isEffect,effectTimeSubmit,this.search.hint,JSON.stringify(selectedList),shopIds, (data) => {
              this.$toast("调价成功");
              this.orderList = [];
              this.selectedId = "";
            }, (data) => {
            }, true)
          }
        }, true);
      },
      btnSelectTableTr(item){
        let selectedStatus = item.isSelected;
        this.orderList.forEach((item1) => {
          item1.isSelected = false;
        });
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.selectedId = item.materialId;
        }else {
          this.selectedId = "";
        }
      },

      showDc(){
        this.$ajax.common.listDistributionCenter.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].dcName,
            })
          }
          this.search.dcList = array;
        }, (data) => {
        }, true)
      },
      updateDc(key) {
        this.search.dcId = key;
        this.orderList = [];
        this.shopList = [];
        this.shopSelectedList = [];
      },
      btnShop(){
        if(this.isEmpty(this.search.dcId)){
          this.$toast("请选择配送中心");
          return;
        }
        this.shopSelectedList = [];
        //显示门店列表
        this.$ajax.distributionCenter.listShop.bind(this)(this.search.dcId, new Page(100, 1), (data) => {
          let list = data.data.list;
          list.forEach((item) => {
            item.isSelected = false;
          });
          this.shopList = list;
        }, (data) => {
        }, true);
        this.isDialogShopShow = true;
      },
      btnSelectTableTrDialogShop(item){
        let selectedStatus = item.isSelected;
        item.isSelected = !selectedStatus;
        if(item.isSelected){
          this.shopSelectedList.push(item.id);
        }else {
          for(let i=0;i<this.shopSelectedList.length;i++){
            if(item.id===this.shopSelectedList[i]){
              this.shopSelectedList.splice(i, 1);
              return
            }
          }
        }
      },
      closeDialogShop(){
        this.shopList = [];
        this.shopSelectedList = [];
        this.isDialogShopShow = false;
      },
      btnConfirmShopDialog(){
        if(this.shopSelectedList.length<1){
          this.$toast("请选择调价门店");
          return
        }
        this.shopList = [];
        this.isDialogShopShow = false;
      },
      btnDeleteMaterial(){
        if(this.isEmpty(this.selectedId)){
          this.$toast("请先选中一条数据");
          return;
        }
        this.orderList.some((item, i)=>{
          if(item.materialId===this.selectedId){
            this.orderList.splice(i, 1);
            this.$toast("删除成功");
            return true
          }
        });
      },
      btnAddMaterial(){
        if(this.isEmpty(this.search.dcId)){
          this.$toast("请选择配送中心");
          return;
        }
        if(this.shopSelectedList.length<1){
          this.$toast("请选择调价门店");
          return;
        }
        this.isDialogMaterialShow = true;
      },
      btnConfirmMaterialDialog(){
        if (this.isEmpty(this.dialogMaterial.materialId)) {
          this.dialogMaterial.hintDialog = "请选择调价货品";
          return
        }
        if (this.isEmpty(this.priceDialog)) {
          this.dialogMaterial.hintDialog = "请输入调后配送价";
          return
        }
        if(this.orderList.some((item, i)=>{
          if(item.materialId===this.dialogMaterial.materialId){
            return true
          }
        })){
          this.dialogMaterial.hintDialog = "该货品已存在";
          return
        }
        let item = {
          materialId: this.dialogMaterial.materialId,
          unit: this.dialogMaterial.unit,
          unitPrice: this.dialogMaterial.unitPrice,
          materialNum: this.dialogMaterial.materialNum,
          name: this.dialogMaterial.name,
          materialSpecs: this.dialogMaterial.materialSpecs,
          isSelected: false,
          newPrice: this.priceDialog.trim()
        };
        this.orderList.push(item);
        this.closeDialogMaterial();
      },
      closeDialogMaterial(){
        this.dialogMaterial = {
          materialId: "",
          materialName: "",
          materialSearchItems: [],
          unit: "",
          unitPrice: "",
          materialNum: "",
          name: "",
          hintDialog: "",
          materialSpecs:""
        };
        this.priceDialog = "";
        this.isDialogMaterialShow = false;
      },
      acquireMaterialItemMaterial(search) {
        let shopIds = this.shopSelectedList[0];
        for(let i=1;i<this.shopSelectedList.length;i++){
          shopIds = shopIds + "," + this.shopSelectedList[i];
        }
        this.$ajax.priceManage.searchRequireMaterials.bind(this)(search,this.search.dcId,shopIds, (data) => {
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].materialId,
              value: data.data[i].materialNum + "  " + data.data[i].materialName,
              unit: data.data[i].unit,
              unitPrice: data.data[i].unitPrice,
              materialNum: data.data[i].materialNum,
              name: data.data[i].materialName,
              materialSpecs:data.data[i].materialSpecs,
            })
          }
          this.dialogMaterial.materialSearchItems = array;
        }, this.failDefault, false);
      },
      updateMaterialNameMaterial(key) {
        this.dialogMaterial.materialId = key;
        if(!this.isEmpty(key)){
          for(let i=0;i<this.dialogMaterial.materialSearchItems.length;i++){
            if(this.dialogMaterial.materialSearchItems[i].key === key){
              this.dialogMaterial.unit = this.dialogMaterial.materialSearchItems[i].unit;
              this.dialogMaterial.unitPrice = this.dialogMaterial.materialSearchItems[i].unitPrice;
              this.dialogMaterial.materialNum = this.dialogMaterial.materialSearchItems[i].materialNum;
              this.dialogMaterial.name = this.dialogMaterial.materialSearchItems[i].name;
              this.dialogMaterial.materialSpecs = this.dialogMaterial.materialSearchItems[i].materialSpecs;
              return;
            }
          }
        }else {
          this.dialogMaterial.hintDialog = "";
          this.dialogMaterial.unit = "";
          this.dialogMaterial.unitPrice = "";
          this.dialogMaterial.materialNum = "";
          this.dialogMaterial.name = "";
          this.dialogMaterial.materialSpecs = "";
        }
      },
      check1() {
        this.search.isEffect = !this.search.isEffect;
      },
      failDefault() {
      },
      timeToDate(time){
        return this.isEmpty(time)?"":time.substring(0,10)
      },
    }
  }
</script>

<style scoped>
  .width_408{width: 408px;}
  .width_240{width: 240px;}
  .txt_hint_dialog{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
    color: #FFB54C;
    text-align: center;
  }
  .cs_table tbody{max-height: 411px;}
  .div_cbtn{
    display: inline-block;
    position: relative;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #333333;
  }
  .txt_cbtn {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 22px;
    height: 22px;
    cursor: pointer;
    left: 0;
    outline: none;
    -webkit-appearance: none;
  }
  .icon_cbtn {
    display: inline-block;
    vertical-align: top;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background: url(../../assets/image/icon_cbtn.png) no-repeat center;
    background-size: 16px 16px;
  }
  .on {
    background: url(../../assets/image/icon_cbtn_checked.png) no-repeat center;
    background-size: 16px 16px;
  }
  .txt_hint_table{
    position: relative;
    width: 100%;
    height: 20px;
    line-height: 20px;
  }
  .margin_left_8{margin-left: 8px;}
  .width_80{width: 80px;}
  .margin_top_12{margin-top: 12px;}
  .width_246{width: 246px;}
  .margin_left_18{margin-left: 18px;}
</style>



// WEBPACK FOOTER //
// src/page/price/RequirePriceHandle.vue